import { z } from 'zod';

/** Where a clearance search looks. Prices a title report; recorded but not priced on a script report. */
export const SCOPES = ['north_america', 'worldwide'] as const;
export const scopeSchema = z.enum(SCOPES);
export type Scope = z.infer<typeof scopeSchema>;

/** Turnarounds in business days, shared by every product. `PRODUCT_TURNAROUNDS` says which a product offers. */
export const TURNAROUND_DAYS = [1, 3, 5] as const;
export const turnaroundDaysSchema = z.literal(TURNAROUND_DAYS);
export type TurnaroundDays = z.infer<typeof turnaroundDaysSchema>;
